module.exports = __webpack_public_path__ + "img/05—Applications—Speed Test 06 > WLAN > Final State.a8723101.jpg";